import { useUnitOfMeasureTranslation } from 'support/helpers/unitOfMeasure/unitOfMeasure';

export const PreferredUnitItem = ({ order, unitOfMeasure }: { order: number; unitOfMeasure: string }) => {
  const label = useUnitOfMeasureTranslation({ unitOfMeasure });

  return (
    <li className="flex items-center gap-2 text-sm text-gray-700">
      <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xs font-medium text-gray-600">
        {order}
      </span>
      {label}
    </li>
  );
};
